<template>
    <section class="section-hero section-shaped my-0" style="z-index:1; background-color: rgb(136 178 231);">
        <div class="shape shape-style-1 shape-primary" style="
                background-image: url(img/theme/main.png);
                background-size: cover;
                background-position-x: center;
                overflow: hidden;
                background-position-y: 1rem;
                background-repeat: no-repeat;
                ">
            <div>
                <video autoplay muted loop class="bg-video">
                    <source src="img/theme/main.png" type="image/png" />
                </video>
                <!-- <audio id="mainAudio" src="img/theme/main1.mp3" autoplay loop style="visibility: hidden;"></audio> -->
            </div>

            <span class="span-150"></span>
            <span class="span-50"></span>
            <span class="span-50"></span>
            <span class="span-75"></span>
            <span class="span-100"></span>
            <span class="span-75"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
        </div>
        <div class="container shape-container d-flex align-items-center">
            <div class="col px-0">
                <div class="row justify-content-center align-items-center">
                    <div class="col-lg-7 text-center pt-lg">
                        <img src="img/brand/logo-white.png"
                            style="width: 100%; background-color: #ffffff50; border-radius: 2rem;" class="img-fluid">
                        <p class="lead text-white mt-4 mb-5"></p>
                    </div>
                </div>
                <div class="row align-items-center justify-content-around stars-and-coded">
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default { };
</script>
<style>
.bg-video {
    height: 100vh;
    width: 100vw;
    object-fit: cover;
}
</style>
